import { render, staticRenderFns } from "./historia.vue?vue&type=template&id=9437de98&scoped=true&"
import script from "./historia.vue?vue&type=script&lang=js&"
export * from "./historia.vue?vue&type=script&lang=js&"
import style0 from "./historia.vue?vue&type=style&index=0&id=9437de98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9437de98",
  null
  
)

export default component.exports